<!-- line.html and line.component are the templates for all annotations except pins -->
<!-- refactoring later; call it a more generic template and component -->

<!-- Loading... -->
<div  class="mt-4 w-100 text-center" *ngIf="loading">
    <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
</div>

<!-- Capture screenshot -->
<div id="screen-grabber" cdkDrag *ngIf="screenCapture">
  <div class="canvas" (click)="canvasClick();">
    <b class="fdm-link closer" (click)="screenCapture = false"><fa-icon icon="times-circle"></fa-icon></b>
    <b class="fdm-link saver" (click)="saveScreenshot()"><fa-icon icon="cut"></fa-icon></b>
    <b class="fdm-link dragger" cdkDragRootElement="#screen-grabber" cdkDragHandle><fa-icon icon="arrows"></fa-icon></b>
    <b class="fdm-link sizer" (mousedown)="canvasSizerDo($event)" (mousemove)="canvasSizerDoing($event)" (mouseup)="canvasSizerDone($event)">
      <fa-icon icon="expand-arrows"></fa-icon>
    </b>
  </div>
</div>

<!-- Annotation tools-->
<div class="fdm-floatbar" *ngIf="!loading && annotation">
    <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

      <!-- close annotation -->
      <li *ngIf="!isNewAnnotation" class="fdm-linked fdm-options-button pointer" (click)="save();clickCloseAnnotation();" [matTooltip]="'GENERIC.CLOSE' | translate"><fa-icon icon="times"></fa-icon></li>
      <li *ngIf="isNewAnnotation" class="fdm-linked fdm-options-button pointer" (click)="save(true);clickCloseAnnotation(false);" [matTooltip]="'GENERIC.CLOSE' | translate"><fa-icon icon="times"></fa-icon></li>

      <!-- save view -->
      <li class="fdm-linked fdm-options-button pointer" (click)="updateAnnotationCameraCoords()" id="save-view" matTooltip=" {{ 'MAP.SAVE_VIEW' | translate }}">
        <fa-icon icon="thumbtack"></fa-icon>
      </li>

      <!-- fly-to camera -->
      <li class="fdm-linked fdm-options-button pointer" (click)="mapService.helper.sendCameraTo(annotation)" id="fly-camera" [matTooltip]="'MAP.FLY_TO' | translate">
        <fa-icon icon="paper-plane"></fa-icon>
      </li>

      <!-- show images -->
      <li id="find-images" class="fdm-linked fdm-options-button pointer" (click)="showImages(true)" matTooltip="{{ 'MAP.FIND_IMAGES' | translate }}">
        <fa-icon icon="search-location"></fa-icon>
      </li>

      <!-- show screen capture -->
      <li class="fdm-linked fdm-options-button pointer" [class.fdm-icon-selected]="screenCapture" (click)="captureScreenshot()" matTooltip="{{ 'GENERIC.SCREENSHOT' | translate }}">
        <fa-icon icon="crop"></fa-icon>
      </li>
      <h2>{{ 'MAP.'+type | translate }} {{ 'MAP.SHAPES' | translate }} <span *ngIf="shapes?.length > 1" class="fdm-count">{{ shapes?.length }}</span> 
          <fa-icon class="fdm-linked fdm-pointer danger ml-2" (click)="del()" [matTooltip]="'GENERIC.DELETE' | translate" icon="trash"></fa-icon>
      </h2>
    </div>

     <div class="fdm-sidebar-body fdm-sidebar-content fdm-buttons fdm-form-field-tight">
    <!-- drag=[{{ isDragging }}] shape=[{{ shapeMaker?.selectedShape }}] shapes=[{{ shapes?.length }}]
      <textarea style="width:100%;height:120px;font-size:8px;">{{ shapes | json }}</textarea> -->

    <!-- <ul *ngIf="mapService?.viewer?.entities" style="margin:0;padding:0;padding-left:9px;">
      <li *ngFor="let e of mapService.viewer.entities.values" style="font-size:9px;border-bottom:solid 1px #ccc;">
        {{ e.id }}<br/> {{ e.name }}
      </li>
    </ul> -->

      <!--
      <b>{{ 'MAP.MEASUREMENT_MODE' | translate }}</b>
      <div>
        <span class="float-left pt-2 mr-2">{{ 'MAP.' + mode | translate }}</span>
        <a mat-mini-fab [color]="mouseMode == 'MODE_ADD'?'primary':null" [matTooltip]="'MAP.line' | translate"  (click)="changeMode('MODE_ADD')">
          <fa-icon class="mt-2" icon="slash"></fa-icon>
        </a>
        <a mat-mini-fab  [color]="mouseMode == 'MODE_SELECT'?'primary':null" (click)="changeMode('MODE_SELECT')"
            [matTooltip]="'MAP.SELECT' | translate">
          <fa-icon icon="mouse-pointer"></fa-icon>
        </a>
      </div> -->


      <!-- Annotation name -->
      <div class="fdm-choice-box">
        <label>{{ 'MAP.NAME' | translate }} </label>
        <div>
          <input matInput [(ngModel)]="annotation.name">
        </div>
      </div>

      <!-- Notes field -->
      <div class="fdm-choice-box">
        <label>{{ 'MAP.DESC' | translate }}</label>
        <div>
          <textarea id="annotation-notes" matInput [(ngModel)]="annotation.desc"></textarea>
        </div>
      </div>

      <!-- Categories - important, urgent etc. -->
      <div class="fdm-choice-box" style="margin-bottom:5px;">
        <label (click)="viewCategories = !viewCategories">{{ 'GENERIC.ACL.CATEGORIES' | translate }} <fa-icon [icon]="viewCategories ? 'chevron-up' : 'chevron-down'"></fa-icon></label>
        <div *ngIf="viewCategories" class="show-choice clearfix">
        <ng-select multiple="true" [(ngModel)]="annotation['categories']" id="annotation-categories" [items]="categoriesSuggestions" [addTag]="addTagFn" (change)="save()">
          <!-- <ng-option *ngFor="let item of categoriesSuggestions">{{ item['$ngOptionLabel'] | normaliseAcl }}</ng-option> -->
        </ng-select>
        </div>
      </div>

      <!-- Color -->
      <ng-container *ngIf="type == 'poi'">
        <div class="fdm-choice-box">
          <label (click)="viewColors = !viewColors">{{ 'MAP.COLOR' | translate }} <fa-icon [icon]="viewColors ? 'chevron-up' : 'chevron-down'"></fa-icon></label>
          <div *ngIf="viewColors" class="show-choice clearfix">
            <div [class]="'fdm-circle-choice float-left fdm-annotation-color-white fdm-annotation-background-color-' + cur"
                  *ngFor="let cur of ['red','green','blue','yellow','orange','grey']"
                  (click)="annotation.color = cur">
              <fa-icon *ngIf="annotation.color == cur" icon="check"></fa-icon>
            </div>
          </div>
        </div>  

        <!-- Icons (pins only)-->
        <div class="fdm-choice-box">
          <label (click)="viewIcons = !viewIcons">{{ 'GENERIC.ICON' | translate }} <fa-icon [icon]="viewIcons ? 'chevron-up' : 'chevron-down'"></fa-icon></label>
          <div *ngIf="viewIcons" class="show-choice clearfix">
            <div *ngFor="let cur of ['map-marker-alt','flag','exclamation-triangle']"
                [class]="'fdm-circle-choice float-left fdm-annotation-color-grey fdm-annotation-background-color-' + ( annotation.icon ? ( annotation.icon == cur ? 'selected' : 'unselected' ) : cur == 'map-marker-alt' ? 'selected' : 'unselected' ) "
                (click)="annotation.icon = cur">
              <fa-icon [icon]="cur"></fa-icon>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="type == 'poi' || type == 'multiPoi'">
        <div class="fdm-choice-box">
          <mat-checkbox [(ngModel)]="annotation['lockPositions']">{{ 'MAP.LOCK_POSITIONS' | translate }}</mat-checkbox>
        </div>
      </ng-container>


      <!-- Calculation labels (except pins and multi-points)-->
      <div class="fdm-choice-box" style="margin-bottom:5px;" *ngIf="type !== 'poi' && type !='multiPoi'">
        <mat-slide-toggle
          color="primary" id="show-labels"
          [(ngModel)]="annotation['showLabels']" (change)="flipCalcLabels();save()">
          <span style="font-size:12px;color:#888;">{{ 'MAP.CALCULATION_LABELS' | translate }}</span>
        </mat-slide-toggle>
      </div>

      <!-- Show options-->
      <ul *ngIf="type != 'poi'" class="fdm-sidebar-list fdm-sidebar-list-tight clearfix">
        <li *ngFor="let s of shapes; let idx = index;" class="fdm-sidebar-list-options" [class.fdm-list-options-selected]="shapeMaker.selectedShape == idx">

          <div class="fdm-layer-tools" style="width:50px!important;padding-top:4px;padding-right:8px;">
            <fa-icon *ngIf="!s.showOptions" class="fdm-layer-icon-gray" icon="chevron-down" matTooltip="{{ 'GENERIC.OPTIONS' | translate }}" (click)="s.showOptions = true"></fa-icon>
            <fa-icon *ngIf="s.showOptions" class="fdm-layer-icon-gray" icon="chevron-up" matTooltip="{{ 'GENERIC.OPTIONS' | translate }}" (click)="s.showOptions = false"></fa-icon>
          </div>

          <div style="padding:4px 8px;" class="fdm-link" (click)="selectedShape = shapeMaker.selectShape(idx,shapes);showCalculateOptions=false">
            <b>{{ type | normaliseAcl | async}} {{ idx + 1 }}</b> <!-- ({{ s?.points?.length }} points) -->
            <!-- [{{ entityHelper?.annot_shape_ref[annotation?.id][idx] }}] -->

            <!-- don't allow to delete the first shape; there's always one! -->
            <fa-icon *ngIf="shapes?.length > 1" icon="trash" class="fdm-linked fdm-pointer danger ml-2" style="font-size:12px;" (click)="deleteShape(idx)" [matTooltip]="'GENERIC.DELETE' | translate"></fa-icon>
          </div>

          <div class="clearfix"></div>

          <div *ngIf="s.showOptions" class="fdm-layer-options">
            <div *ngIf="s.calc" class="fdm-info-box fdm-choice-box">
              <!-- <textarea style="width:100%;height:200px;font-size:10px;">{{ s.calc | json }}</textarea> -->
            
              <!-- Perimeter length -->
              <div *ngIf="s.calc.length">
                <div class="fdm-line-label"> {{'MAP.PERIMETER_LENGTH' | translate }}  </div> <b>{{ mappingHelper.getLocalisedValue(s.calc.length,annotation) }}</b>
                
                <!-- <div style="border:solid 1px green;margin:10px 0;">
                  <div (click)="showChart = !showChart">chartData [{{ showChart }}]</div>
                  <textarea style="width:100%;height:100px;font-size:8px;color:#444;">{{ chartData | json }}</textarea>
                </div> -->
                

                <ng-container *ngIf="hasProfiler">

                  <div (click)="toggleShowProfileOptions()" class="fdm-line-label fdm-linked"> {{'MAP.SAMPLING_OPTIONS' | translate }}  </div>

                  <div class="fdm-layer-tools" style="width:50px!important;padding-top:4px;padding-right:8px;">
                    <fa-icon *ngIf="!showProfileOptions" class="fdm-layer-icon-gray" icon="chevron-down" matTooltip="{{ 'GENERIC.OPTIONS' | translate }}" (click)="toggleShowProfileOptions()"></fa-icon>
                    <fa-icon *ngIf="showProfileOptions" class="fdm-layer-icon-gray" icon="chevron-up" matTooltip="{{ 'GENERIC.OPTIONS' | translate }}" (click)="toggleShowProfileOptions()"></fa-icon>
                  </div>

                  <div *ngIf="showProfileOptions" style="padding: 15px 5px 15px 10px;margin: 2px 0;border: solid 1px #ccc;background-color: #fff;">
                    <mat-progress-bar color="accent" *ngIf="calculating" class="mt-1" [mode]="totalCalc == 1 ? 'indeterminate' : 'determinate'" [value]="percentFinished"></mat-progress-bar>
                    <button *ngIf="calculating" class="mt-2 ml-2" mat-raised-button color="default" (click)="cancelCalculating()">{{'GENERIC.CANCEL' | translate }}</button>
                    <!-- <button *ngIf="!calculating" class="mt-2 ml-2" mat-raised-button color="primary" (click)="calculateProfiler()">{{'MAP.PROFILER' | translate }}</button> -->
                    
                    <!-- Line profiler -->
                    <div *ngIf="!calculating && profile && profile.samplingRate">

                      <p>{{ 'MAP.MEASUREMENT_EVERY' | translate }} {{ samplingRate/10 | round:2 }}m ({{ profile.totalSamplingPoints }} points)</p>

                      <mat-slider color="primary" class="fdm-layer-slider" style="width:100%;margin:0!important;padding:0!important;margin-top:10px!important;"
                        [min]="profile.samplingRate.min" [max]="profile.samplingRate.max" step="0.01" [(ngModel)]="samplingRate" (input)="calculateProfiler($event)"></mat-slider>
  
                      <div *ngIf="annotation ? !annotation['clickedOnType'] : true"><b> {{ 'MAP.SAMPLING_ON' | translate }}</b><br>
                        <div class="form-group">
                          <mat-radio-group [(ngModel)]="sampleMethod" [value]="sampleMethod">
                            <mat-radio-button value="terrain">{{ 'MAP.SAMPLE_TERRAIN' | translate }} </mat-radio-button><br>
                            <mat-radio-button value="model">{{ 'MAP.SAMPLE_TILES' | translate }}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </div>

                      <!-- <div><b> {{ 'MAP.SAMPLING_RESOLUTION' | translate }}</b><br>
                        <div class="form-group">
                          <mat-radio-group [(ngModel)]="sampleResolution" [value]="sampleResolution">
                            <mat-radio-button value="high">{{ 'MAP.SAMPLING_RESOLUTION_HIGH' | translate }} </mat-radio-button><br>
                            <mat-radio-button value="low">{{ 'MAP.SAMPLING_RESOLUTION_LOW' | translate }}</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </div> -->
  
                    </div>
                    
                    <button *ngIf="!calculating" class="mt-2 ml-2" mat-raised-button color="accent" (click)="startProfiler()" id="line-profiler">{{'MAP.PROFILER_RUN' | translate }}</button>
  
                  </div>
                  
                </ng-container>                
              </div>

              <div id="profileGraph" #profileGraph [sizeable]="true" *ngIf="chartData && showChart">
                <fa-icon class="fdm-linked fdm-text-large" style="position:fixed;right:395px;" icon="times-circle" (click)="closeProfiler()"></fa-icon>
                <div class="innerGraph"><ngx-charts-area-chart
                  [view]="[profileGraph.offsetWidth, profileGraph.offsetHeight - 10]"
                  [scheme]="chart.colorScheme"
                  [legend]="chart.legend"
                  [showXAxisLabel]="chart.showXAxisLabel"
                  [showYAxisLabel]="chart.showYAxisLabel"
                  [xAxis]="chart.xAxis"
                  [yAxis]="chart.yAxis"
                  [xAxisLabel]="chart.xAxisLabel"
                  [yAxisLabel]="chart.yAxisLabel"
                  [xScaleMin]="chart.xScaleMin"
                  [xScaleMax]="chart.xScaleMax"
                  [yScaleMin]="chart.yScaleMin"
                  [yScaleMax]="chart.yScaleMax"
                  [timeline]="chart.timeline"
                  [results]="chartData"
                  > <!-- (deactivate)="deactivateChart($event)" (hover)="hoverChart($event)" -->
                </ngx-charts-area-chart></div>
              </div>

              <!-- Total area -->
              <div *ngIf="s.calc.area">
                <div class="fdm-line-label"> {{'MAP.TOTAL_AREA' | translate }} </div> <b>{{ mappingHelper.getLocalisedValue(s.calc.area,annotation) }}<sup>2</sup></b>
              </div>

              <!-- Total volume -->
              <div *ngIf="canCalculateVolume && ! s.calc.volume">
                <div class="fdm-line-label"> {{'MAP.TOTAL_VOLUME' | translate }}</div>

                <!-- <fa-icon *ngIf="!calculating && !showCalculateOptions" icon="calculator" class="fdm-link" style="text-decoration:underline;" (click)="showCalculateOptions=true"></fa-icon> -->

                <button *ngIf="!calculating && !showCalculateOptions" mat-raised-button color="primary" (click)="showCalculateOptions=true">
                  <fa-icon icon="calculator" class="fdm-link"></fa-icon> {{'MAP.NEW_VOLUME' | translate }}
                </button>

                <mat-progress-bar color="accent" *ngIf="calculating" class="mt-1" [mode]="totalCalc == 1 ? 'indeterminate' : 'determinate'" [value]="percentFinished"></mat-progress-bar>               
                <button *ngIf="calculating" class="mt-2 ml-2" mat-raised-button color="default" (click)="cancelCalculating()">{{'GENERIC.CANCEL' | translate }}</button>

                <div *ngIf="showCalculateOptions" class="mt-2 ml-2" style="font-size: 13px;">
                
                  <b>{{ 'MAP.MEASUREMENT_SELECTION' | translate }}</b>
  
                  <!-- Volume calculation method selection -->
                  <mat-radio-group [(ngModel)]="volumeChoiceOption">
                    <mat-radio-button [value]="baseSurface">{{'MAP.VOLUME_CALCULATE.TRIANGULATED_BASE_SURFACE' | translate }}</mat-radio-button><br>
                    <mat-radio-button [value]="baseDesign">{{'MAP.VOLUME_CALCULATE.BASE_DESIGN' | translate }}</mat-radio-button>
                    <mat-select [placeholder]="'MAP.VOLUME_CALCULATE.SELECT_DESIGN' | translate" style="background-color:#fff;font-size: 13px;margin:3px 0 5px 35px;width:200px;" [(ngModel)]="baseDesignTransform" *ngIf="volumeChoiceOption === baseDesign">
                      <mat-option [value]="none" >
                        {{ 'COLORS.MODELS.None' | translate }}
                      </mat-option>
                      <ng-container *ngFor="let item of mapService.sceneTransforms">
                        <mat-option *ngIf="item.type_uid === 'three-d-tiles'" [value]="item" >
                          {{item.input.name}}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                    <mat-radio-button [value]="minHeight">{{'MAP.VOLUME_CALCULATE.VOLUME_MIN_HEIGHT' | translate }}</mat-radio-button> <br>
                    <mat-radio-button [value]="customHeight">{{'MAP.VOLUME_CALCULATE.VOLUME_CUSTOM_HEIGHT' | translate }}</mat-radio-button>
                    <input type="number" style="width: 50px;margin-top: -3px;position: absolute;" class="ml-2" [(ngModel)]="customHeightValue" *ngIf="volumeChoiceOption === customHeight" [placeholder]="'MAP.VOLUME_CALCULATE.CUSTOM_HEIGHT' | translate">
                    
                    <!-- <br>
                    <mat-radio-button [value]="baseDesign">{{'MAP.VOLUME_CALCULATE.BASE_DESIGN' | translate }}</mat-radio-button>
                    --> </mat-radio-group>  <br>

                    <ng-container *ngIf="zone">
<!--
                      gridX=[{{ zone.area.grid.x }}]<br>
                      gridY=[{{ zone.area.grid.y }}]<br>

                      distance=[{{ zone.area.corners.samplingDistance }}]<br>
                      distanceCalc=[{{ zone.area.grid.samplingDistance }}]<br>
-->
                      <div *ngIf="zone" class="mt-2 mb-2">
                        <b>{{ 'MAP.MEASUREMENT_RESOLUTION' | translate }} ({{ zone.area.corners.samplingDistance }}m)</b><br>
                        <mat-slider color="primary" class="fdm-layer-slider" style="width:100%;margin:0;padding:0;" [min]="zone.area.corners.samplingDistanceMin" [max]="zone.area.corners.samplingDistanceMax" step="0.01" 
                        [(ngModel)]="zone.area.corners.samplingDistance"
                        (input)="gridInput($event)" (change)="gridChange($event)"></mat-slider>
                      </div>
                    </ng-container>

                  <!-- <mat-select [placeholder]="'MAP.VOLUME_CALCULATE.SELECT_DESIGN' | translate" class="mt-1" style="font-size: 14px;"  [(ngModel)]="baseDesignTransform" *ngIf="volumeChoiceOption === baseDesign">
                    <ng-container *ngFor="let item of mapService.sceneTransforms">
                      <mat-option *ngIf="item.type_uid === 'three-d-tiles'" [value]="item" >
                        {{item.input.name}}
                      </mat-option>
                    </ng-container>
                  </mat-select>  <br> -->

                  <!-- Calculate volume -->
                  <button id="calculate-volume" class="mt-2" mat-raised-button color="primary"
                    [disabled]="calculating" 
                    (click)="showCalculateOptions=false;calculating=true;startCalcPolygonVolume()"
                    [matTooltip]="'MAP.CALCULATE_VOLUME' | translate">
                    {{'MAP.CALCULATE_VOLUME' | translate }}
                  </button>                

                <!-- <div class="mt-1">
                    <button mat-raised-button [disabled]="takingScreenShot"  color="primary" (click)="takeScreenShotForVolume()"
                            [matTooltip]="'MAP.CALCULATE_VOLUME' | translate">
                      {{'MAP.TAKE_SCREENSHOT' | translate }}
                    </button>
                      <mat-progress-bar *ngIf="takingScreenShot" style="height: 15px;" class="mt-1" mode="indeterminate" ></mat-progress-bar>
                    &lt;!&ndash;<div  *ngIf="canvasUrl">
                      <img style="width: 100%" [src]="canvasUrl">
                    </div>&ndash;&gt;
                  </div>-->
                </div>
              </div>

              <!-- Negative and positive volume -->
              <div *ngIf="s.calc.volume" class="mb-2">
                <div class="fdm-line-label"> {{'MAP.TOTAL_VOLUME' | translate }} </div> <b>{{ mappingHelper.getLocalisedValue(s.calc.volume,annotation) }}<sup>3</sup></b>
                <div *ngIf="s.calc.volumeNeg">
                  <div class="fdm-line-label"> {{'MAP.NEGATIVE_VOLUME' | translate }} </div> <b>{{ mappingHelper.getLocalisedValue(s.calc.volumeNeg,annotation) }}<sup>3</sup></b>
                </div>
                <div *ngIf="s.calc.volumePos">
                  <div class="fdm-line-label"> {{'MAP.POSITIVE_VOLUME' | translate }}</div> <b>{{ mappingHelper.getLocalisedValue(s.calc.volumePos,annotation) }}<sup>3</sup></b>
                </div>

                <button mat-raised-button color="primary" (click)="s.calc.volume=null;showCalculateOptions=true">
                  <fa-icon icon="trash" class="fdm-link"></fa-icon> {{'MAP.NEW_VOLUME' | translate }}
                </button>
                <!-- <fa-icon icon="trash" class="ml-2 fdm-link" style="font-size:12px;text-decoration:underline;" (click)="s.calc.volume=null;showCalculateOptions=false"></fa-icon> -->
              </div>
              
              <!-- <div *ngIf="s.calc.volume && s.calc.volumePoints">
                <span *ngFor="let p of s.calc.volumePoints"> {{ p.height }} </span>
              </div> -->         
            </div>

            <!-- Annotation color -->
            <div class="fdm-choice-box">
              <div class="fdm-line-label">{{ 'MAP.COLOR' | translate }}</div>
                <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" 
                  [(colorPicker)]="s.color" 
                  (colorPickerChange)="setCurrentColor($event, idx)" 
                  [style.background]="s.color" 
                  cpOutputFormat="rgba" 
                  cpPosition="bottom"
                  cpPositionOffset="50%"
                  [cpPositionRelativeToArrow]="true"
                  matTooltip="{{ 'MAP.COLOR' | translate }}">
                  <fa-icon icon="chevron-down"></fa-icon>
                </div>
            </div>

            <!-- Line width -->
            <div class="fdm-choice-box" [class.noshow]="type !== 'line' && s.clamping">
              <div translate class="fdm-line-label">MAP.LINE_WIDTH</div>
              <input id="annotation-linewidth" class="fdm-text-input-choice" matTooltip="{{'MAP.LINE_WIDTH' | translate }}" 
                type="number" min="1.0" max="20.0" step="0.5" value="4.0" 
                (change)="setCurrentLineWidth(idx)" [(ngModel)]="s.lineWidth" />    
            </div>

            <!-- Clamp to model -->
            <div class="fdm-choice-box">
              <div translate class="fdm-line-label">MAP.CLAMP_TO_MODEL</div>
              <mat-checkbox [(ngModel)]="s.clamping" id="annotation-clamp" (change)="setClampToModel($event,idx)"></mat-checkbox>
            </div>

            <!-- <div class="fdm-choice-box">
              <div class="fdm-line-label">Show shape details</div>
              <mat-checkbox [(ngModel)]="shapes[idx].shapeInfo" (change)="setShapeInfo($event,idx)"></mat-checkbox>
            </div> -->
            
            <!-- <textarea style="width:100%;height:80px;font-size:9px;">{{ s?.calc | json }}</textarea>
            <textarea style="width:100%;height:200px;font-size:9px;">{{ shapes[idx].points | json }}</textarea> -->
            
            <!-- <textarea style="width:100%;height:200px;font-size:9px;">{{ shapes[idx]?.calc | json }}</textarea> -->
          </div>
        </li>
      </ul>

      <!-- Add another shape (except pins) -->
      <div *ngIf="type != 'poi'" class="clearfix" style="margin-bottom:15px;">
        <button mat-stroked-button color="accent" class="float-left" id="add-another-shape" [matTooltip]="'MAP.ADD_SHAPE' | translate" [disabled]="interactionMode == 'create'" (click)="createShape()"><fa-icon icon="shapes"></fa-icon> {{'GENERIC.ADD' | translate }}</button>
      </div>

      <!-- <div class="fdm-choice-box">
        <span (click)="browsePhotos()" class="float-right fdm-linked" matTooltip="Add photo (so we can create a Snapshot from it)">
          <fa-icon icon="images"></fa-icon>
        </span>
        <span (click)="deleteAttachedPhotos()" class="fdm-linked float-right" *ngIf="photoIds && photoIds?.length" [matTooltip]="'MAP.DELETE_ATTACHED_PHOTOS' | translate">
          <fa-icon icon="trash"></fa-icon>
        </span>
        <label>Snapshot (from photos)</label>
        <div class="clearfix">
  
          <div class="show-choice" *ngIf="screenshotName || screenshotByteCharacters">
            {{ screenshotName }}
            -- <img id="screenShot" *ngIf="screenshotName" style="width:100%;" [vlink]="screenshotName" [model]="annotation"> -
            <img id="screenShotBytes" *ngIf="screenshotByteCharacters" style="width:100%;" [src]="screenshotByteCharacters">
            <fa-icon icon="times" class="danger fdm-linked" (click)="deleteScreenShot(true);" [matTooltip]="'GENERIC.DELETE' | translate"></fa-icon>
          </div>
        </div>

        -- <textarea style="width:100%;height:100px;">{{ this.annotation.photoIds | json }}</textarea> 
      </div> -->

      <!-- GeoJSON attachment -->
      <div class="fdm-choice-box">
        <label>{{ 'MAP.ATTACHMENTS' | translate }}</label>
        <table *ngIf="filesAttached" class="fdm-sidebar-table-list">
            <tr *ngIf="photoTransform?.input">
              <td>
                <img (click)="showDZI(photoTransform)" style="width:100%;" vlink="image.png" [model]="photoTransform">
                <fa-icon icon="times" class="danger fdm-linked" (click)="deleteScreenShot(true)" [matTooltip]="'GENERIC.DELETE' | translate"></fa-icon>
              </td>
            </tr>

          <tr *ngFor="let cur of filesAttached;let i = index;">
            <ng-container *ngIf="cur.mimeType == 'application/json'">
              <td>
                <a [vlink]="cur.name" [model]="annotation"><fa-icon icon="shapes" class="fdm-linked"></fa-icon> GeoJSON</a>
              </td>
            </ng-container>
            
            <!-- Delete screenshot -->
            <ng-container *ngIf="cur.mimeType == 'image/png'">
              <td>
                <img style="width:100%;" [vlink]="cur.name" [model]="annotation">
                <fa-icon icon="times" class="danger fdm-linked" (click)="deleteScreenShot(cur)" [matTooltip]="'GENERIC.DELETE' | translate"></fa-icon>
                <!-- <textarea style="width:100%;height:50px;font-size:9px;">{{ cur | json }}</textarea> -->
              </td>
            </ng-container>
          </tr>
        </table>
      </div>

      <!-- External URL -->
      <div class="fdm-choice-box">
        <span id="annotation-url" class="float-right fdm-linked" matTooltip=" {{ 'MAP.LINK_TOOLTIP' | translate }}" (click)="openExternalLink()">
          <fa-icon icon="cog"></fa-icon>
        </span>
        <label>{{ 'MAP.EXTERNAL_LINK' | translate }}</label>
        <div *ngIf="annotation['externalURL'] && annotation['externalURL'] != ''" (click)="openURL(annotation)">
          <fa-icon icon="link" class="fdm-linked"></fa-icon> {{ annotation['externalURL'] }}
        </div>
      </div>

        <!-- Attributes -->
      <div class="fdm-choice-box">
        <span id="annotation-attributes" class="float-right fdm-linked" [matTooltip]="'MAP.ATTRIBUTES_TOOLTIP' | translate" (click)="addAttrib()">
          <fa-icon icon="plus-circle"></fa-icon>
        </span>
        <label>{{ 'MAP.ATTRIBUTES' | translate }}</label>
        <table *ngIf="annotation['attributes']" class="fdm-sidebar-table-list">
          <tr *ngFor="let cur of annotation['attributes'];let i = index">
            <td width="45%">
              <input class="w-100 attrib_text"  placeholder=" {{'MAP.ATTRIBUTES_KEY' | translate }}" [(ngModel)]="cur.key">
            </td>
            <td width="45%">
              <input class="w-100 attrib_text" placeholder="{{'MAP.ATTRIBUTES_VALUE' | translate }}" [(ngModel)]="cur.value">
            </td>
            <td style="text-align:center;">
              <fa-icon icon="times" class="danger fdm-linked" (click)="delAttrib(i)" [matTooltip]="'GENERIC.DELETE' | translate"></fa-icon>
            </td>
          </tr>
        </table>
      </div>

      <!-- Close annotation -->
      <div class="mt-2 text-right">
        <button mat-flat-button color="primary" *ngIf="!isNewAnnotation" (click)="save();clickCloseAnnotation();" class="float-right fdm-button"><fa-icon icon="times"></fa-icon> {{ 'GENERIC.CLOSE' | translate }}</button>
        <button id="save-shape" mat-flat-button color="primary" *ngIf="isNewAnnotation" (click)="save(true);clickCloseAnnotation(false);" class="float-right fdm-button"><fa-icon icon="save"></fa-icon> {{'GENERIC.SAVE' | translate }}</button>
      </div>

    <!-- <textarea style="width:100%;height:170px;font-size:9px;">{{ shapes | json }}</textarea> -->

<!-- <hr/>
          <b>{{ 'MAP.MEASUREMENT_MODE' | translate }}</b>
          <div>
            <span class="float-left pt-2 mr-2">{{ 'MAP.' + mode | translate }}</span>
            <a mat-mini-fab [color]="mouseMode == 'MODE_ADD'?'primary':null" [matTooltip]="'MAP.line' | translate"  (click)="changeMode('MODE_ADD')">
              <fa-icon class="mt-2" icon="slash"></fa-icon>
            </a>
            <a mat-mini-fab  [color]="mouseMode == 'MODE_SELECT'?'primary':null" (click)="changeMode('MODE_SELECT')"
               [matTooltip]="'MAP.SELECT' | translate">
              <fa-icon icon="mouse-pointer"></fa-icon>
            </a>
          </div>
          <hr/>
          <div *ngIf="errMsg" >
            <div class="alert alert-danger">
              {{ 'MAP.' + errMsg | translate }}
            </div>
          </div>
          <div *ngIf="screenCoordsCartesian && screenCoords && !errMsg" class="mt-2 p-1">
            <b>{{ 'MAP.MEASUREMENT' | translate }}</b>
            <div *ngIf="props">
              <div *ngFor="let p of propsLastTwoPoint">
                <div class="row">
                  <div class="col-sm-8">
                    {{p.name}}
                  </div>
                  <div class="col-sm-4">
                    {{p.value}}{{p.unit}}
                  </div>
                </div>
              </div>
            </div>
          </div> -->

<!--
          <hr/>
          <div>
            <b>{{ 'MAP.POINT_COUNT' | translate }}</b>
            <div>
              <div class="float-right">
                <button *ngIf="points?.length != 0" mat-icon-button  color="warn" (click)="nukePoints()"
                        [matTooltip]="'MAP.CLEAR_POINTS' | translate">
                  <fa-icon icon="eraser"></fa-icon>
                </button>
                <button *ngIf="pointsCopy?.length != 0 " mat-icon-button  color="primary" (click)="undoNukePoints()"
                        [matTooltip]="'MAP.UNDO' | translate">
                  <fa-icon icon="undo"></fa-icon>
                </button>
                <button *ngIf="annotation['points']?.length > 0"  mat-icon-button  color="primary" (click)="addInNewIndex()"
                        [matTooltip]="'MAP.STOP' | translate">
                  <fa-icon icon="stop-circle"></fa-icon>
                </button>
                <button mat-raised-button color="warn" *ngIf="selectedIndexArray.length >  0 && mouseMode === 'MODE_SELECT'" (click)="deleteSelectedDrawing()">
                  {{'MAP.DELETE_SELECTED' | translate }} </button>
              </div>
              <span class="mt-2">
            {{ 'MAP.POINT_COUNT_STR' | translate: { points:points?.length } }}
          </span>
            </div>
          </div>
          <hr/>
        -->
    </div>
  </div>

          <!-- <button mat-button (click)="shapeMaker.selectShape()">sel</button>
          <button mat-button (click)="shapeMaker.unselectShape()">unsel</button> -->          

    <!-- <table class="fdm-debug-table noshow">

      <tr class="banner"><td colspan="3">Annotation DEBUG table</td></tr>
      
      <tr class="header section"><td colspan="2">mode</td><td>{{ mode }}</td></tr>
      <tr class="header"><td colspan="2">mouseMode</td><td>{{ mouseMode }}</td></tr>
      
      !-- <tr class="header section"><td colspan="2">mapSelectedObj</td><td>{{ mapSelectedObj }}</td></tr> -- 
      <tr class="header"><td colspan="2">mapSelectedObj</td><td>{{ mapSelectedObj?.id }} : '{{ mapSelectedObj?.name }}'</td></tr>
      <tr class="header"><td colspan="2">selectedPoint</td><td>{{ selectedPoint?.id }}</td></tr>
      <tr class="header"><td colspan="2">selectedPlane</td><td>{{ selectedPlane }}</td></tr>

      <tr class="header section"><td colspan="2">selectedIndex</td><td>{{ selectedIndex }}</td></tr>
      <tr class="header"><td colspan="2">selectedIndexArray</td><td>[{{ selectedIndexArray.join(', ') }}]</td></tr>
      <tr class="header"><td colspan="2">currentPointsIndex</td><td>{{ currentPointsIndex }}</td></tr>
      <tr class="header"><td colspan="2">points</td><td>{{ points?.length }}</td></tr>
      <tr class="header"><td colspan="2">allPoints</td><td>{{ allPoints?.length }}</td></tr>
      
      <tr class="header section"><td colspan="2">pickedFeatureIs3D</td><td>{{ pickedFeatureIs3D?.id  }}</td></tr>
      <tr class="header"><td colspan="2">picked3DPositionIsValid</td><td>{{ picked3DPositionIsValid  }}</td></tr>
      <tr class="header"><td colspan="2">currentGeo</td><td>{{ currentGeo?.id }}</td></tr>
      <tr class="header"><td colspan="2">allGeo</td><td>{{ allGeo.length }}</td></tr>

      <tr class="split"><td colspan="2"> &nbsp; </td><td></td></tr>
      
      <ng-container *ngFor="let bunch of annotation.points; let idx = index;">
        <tr [class.fdm-list-selected]="selectedIndexArray.indexOf(idx) != -1" style="border-top:dotted 1px #ccc;">
          <td>shape {{ idx }}</td>
          <td colspan="2" style="font-size:11px;">
            color:<b [style.color]="getPropValue('currentColor', idx)">{{ getPropValue('currentColor', idx) }}</b>, 
            line-width:{{ getPropValue('currentLineWidth', idx) }}, 
            clamp:{{ getPropValue('clampToModel', idx) }}

          </td>
        </tr>
        <tr *ngIf="bunch?.length == 0">
          <td> </td>
          <td colspan="2" style="color:red">no points</td>
        </tr>
        <tr *ngFor="let p of bunch; let x = index;">
          <td></td>
          <td>point {{ x }}</td>
          <td style="font-size:6px;">x:{{ p?.coords?.x }}, y:{{ p?.coords?.y }}, z:{{ p?.coords?.z }}</td>
        </tr>
      </ng-container>

      <tr class="header section"><td colspan="2">A.points</td><td>
        <textarea style="width:100%;height:200px;font-size:6px;">{{ annotation?.points | json }}</textarea>
      </td></tr>
      
    </table> -->